/*
 * @Author: your name
 * @Date: 2021-11-18 14:35:27
 * @LastEditTime: 2021-11-18 14:35:28
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /d2d-client/src/pages/admin/booking/PrintBarcode.pagemeta.ts
 */
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'print barcode',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: false,
};
